import { render, staticRenderFns } from "./ApplianceList.vue?vue&type=template&id=50dcb1f7&scoped=true"
import script from "./ApplianceList.vue?vue&type=script&lang=ts"
export * from "./ApplianceList.vue?vue&type=script&lang=ts"
import style0 from "./ApplianceList.vue?vue&type=style&index=0&id=50dcb1f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcb1f7",
  null
  
)

export default component.exports